import * as React from 'react';
import {
    BodyMediumRegular,
    H5Regular,
    SelectTile,
    SmartphoneIcon,
    WalletIcon,
    YStack,
} from 'smoothie';

interface CardPreferenceSelectorProps {
    selectVirtual: (selection: RequestedCardType) => void;
    selectPhysical: (selection: RequestedCardType) => void;
    hasExistingPhysicalCards: boolean;
}

export enum RequestedCardType {
    VIRTUAL_ONLY = 'virtual',
    VIRTUAL_AND_PHYSICAL = 'virtualAndPhysical',
}

export const CardPreferenceSelector = ({
    selectPhysical,
    selectVirtual,
    hasExistingPhysicalCards,
}: CardPreferenceSelectorProps) => {
    return (
        <YStack>
            <H5Regular textAlign="left" marginTop="2%">
                What&apos;s your card{'\n'} preference?
            </H5Regular>
            <YStack marginTop={30} gap={16}>
                <SelectTile
                    icon={SmartphoneIcon}
                    iconLeft
                    title="Virtual card only"
                    description={
                        'Add it to your Apple Wallet\u2122 immediately after confirmation.'
                    }
                    onPress={() => {
                        selectVirtual(RequestedCardType.VIRTUAL_ONLY);
                    }}
                />
                <SelectTile
                    icon={WalletIcon}
                    iconLeft
                    disabled={hasExistingPhysicalCards}
                    title="Virtual and physical cards"
                    description="You'll get a virtual card now and a physical card mailed to you."
                    onPress={() => {
                        selectPhysical(RequestedCardType.VIRTUAL_AND_PHYSICAL);
                    }}
                />
                <BodyMediumRegular textAlign="center" color="$gray1000">
                    Each member is eligible for one physical card.
                </BodyMediumRegular>
            </YStack>
        </YStack>
    );
};
